import {
    GETENTITYMAPPINGLIST_SUCCESS,
    GETENTITYMAPPINGLIST_FAILED,
    RESET_GETENTITYMAPPINGLIST,
    LOADING_GETENTITYMAPPINGLIST,
    NETWORK_ERROR_GETENTITYMAPPINGLIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETENTITYMAPPINGLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETENTITYMAPPINGLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETENTITYMAPPINGLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETENTITYMAPPINGLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETENTITYMAPPINGLIST:
            return (state = initialState);
        default:
            return state;
    }
};
